const layoutTranslation = {
  'header.language': 'Idioma',
  'header.welcome': 'Seja bem-vindo',
  'header.settings': 'Perfil',
  'header.signOut': 'Sair',

  'menu.dashboard.divider': 'Painel',
  'menu.dashboard': 'Início',
  'menu.signOut': 'Sair',
  'menu.settings.divider': 'Configurações',

  'footer.text': 'Todos os direitos reservados.',
};

export default layoutTranslation;
